import { SET_ACCOUNT_PROPERTY_ID } from 'actions';

export function setAccountPropertyId(propertyId: string) {
  return { propertyId, type: SET_ACCOUNT_PROPERTY_ID };
}
